module.exports = __webpack_public_path__ + "static/media/ic_buy_gold.9b486364.svg";